import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import Logo from './Logo';

const SharedFooter = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <footer className="py-8 px-4 border-t border-purple-700 mt-16">
      <div className="container mx-auto text-center">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <Logo size="small" />
          <span className="font-bold">{t('appName')}</span>
        </div>
        <p className="text-gray-300 text-sm">{t('copyright')}</p>
        <div className="flex justify-center space-x-4 mt-4 text-sm flex-wrap">
          <Link to="/about" className="text-gray-400 hover:text-white">
            {t('aboutUs')}
          </Link>
          <span className="text-gray-600">|</span>
          <Link to="/interes" className="text-gray-400 hover:text-white">
            {language === 'es' ? 'Interés' : language === 'en' ? 'Interest' : 'Interesse'}
          </Link>
          <span className="text-gray-600">|</span>
          <Link to="/innovacion-y-hoja-de-ruta" className="text-gray-400 hover:text-white">
            {language === 'es' ? 'Innovación & Roadmap' : language === 'en' ? 'Innovation & Roadmap' : 'Inovação & Roadmap'}
          </Link>
          <span className="text-gray-600">|</span>
          <Link to="/politica-de-privacidad" className="text-gray-400 hover:text-white">
            {t('privacyPolicy')}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default SharedFooter;
